/**
 * @generated SignedSource<<b218284fe429bec692e122a6a640ae5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CalendarDayEventsPanel_events",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CalendarResourceItem_event"
    }
  ],
  "type": "CalendarResource",
  "abstractKey": null
};

node.hash = "64290c39ad81cb6d0032703e864f21ba";

module.exports = node;
